import React from 'react'

import useScenarioScheduleDetails, {
  ScheduledScenarioDetails
} from 'hooks/use-scenario-schedule-details'

// this component wraps the `ScheduledScenarioListItem` to provide it with the latest run
// so that component can remain simple and easily testable
export const ScheduledScenarioDetailsProvider: React.FC<{
  scenarioId: string
  children(
    scenario: ScheduledScenarioDetails,
    isLoading: boolean,
    hasError: boolean
  ): React.ReactNode
}> = ({ scenarioId, children = () => null }) => {
  const { isLoading, hasError, scenarioDetails } =
    useScenarioScheduleDetails(scenarioId)

  if (isLoading || hasError) {
    return children(null, isLoading, hasError)
  }

  return children(scenarioDetails, isLoading, hasError)
}
